import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#home-loan-payment-lite-app', App);
